import moment from 'moment'

/** Converts the date and time strings returned by custom inputs to a valid JS date */
export function transformToDateObj(date, time) {
  return moment(date + ' ' + time, 'DD-MM-YYYY HH:mm')
}
